/* eslint-disable max-len */
import { SvgIconDefaultProps } from './svgIcon.types'

const ReportIcon = ({ className }: SvgIconDefaultProps) => {
  return (
    <svg className={className} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 0C8.3125 0 9 0.6875 9 1.5V12.5C9 13.3438 8.3125 14 7.5 14H6.5C5.65625 14 5 13.3438 5 12.5V1.5C5 0.6875 5.65625 0 6.5 0H7.5ZM7.5 1H6.5C6.21875 1 6 1.25 6 1.5V12.5C6 12.7812 6.21875 13 6.5 13H7.5C7.75 13 8 12.7812 8 12.5V1.5C8 1.25 7.75 1 7.5 1ZM2.5 6C3.3125 6 4 6.6875 4 7.5V12.5C4 13.3438 3.3125 14 2.5 14H1.5C0.65625 14 0 13.3438 0 12.5V7.5C0 6.6875 0.65625 6 1.5 6H2.5ZM2.5 7H1.5C1.21875 7 1 7.25 1 7.5V12.5C1 12.7812 1.21875 13 1.5 13H2.5C2.75 13 3 12.7812 3 12.5V7.5C3 7.25 2.75 7 2.5 7ZM10 3.5C10 2.6875 10.6562 2 11.5 2H12.5C13.3125 2 14 2.6875 14 3.5V12.5C14 13.3438 13.3125 14 12.5 14H11.5C10.6562 14 10 13.3438 10 12.5V3.5ZM11 3.5V12.5C11 12.7812 11.2188 13 11.5 13H12.5C12.75 13 13 12.7812 13 12.5V3.5C13 3.25 12.75 3 12.5 3H11.5C11.2188 3 11 3.25 11 3.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default ReportIcon
